// **  Initial State
const initialState = {
  clearDynamicForm: false
}

const clearFormsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CLEAR_DYNAMIC_FORM':
      return { ...state, clearDynamicForm: action.data }
    default:
      return state
  }
}

export default clearFormsReducer
